import { FlexWrapper } from '@intigral/shared';
import React from 'react';
import { useConfigurationSections } from '../../hooks/useConfiguration';
import { useUserReminders } from '../../store/reducers/reminderSlice';
import { getUserInfo } from '../../utils/user';
import { TransformedVOD } from '../../utils/vodTransformer';
import { FullVODCarouselItem } from './FullVODCarouselItem';

interface FullVODCarouselProps {
    content?: TransformedVOD[];
    componentType?: string;
    componentName?: string;
    itemsCount?: number;
    screenName?: string;
    carouselType?: string;
}

const FullVODCarousel: React.FC<FullVODCarouselProps> = ({
    content,
    componentType,
    componentName,
    itemsCount,
    screenName,
    carouselType,
}) => {
    // Using React Query instead of Redux for configuration
    const { paidVsFree, autoTrailerCarousel, promotionProviderImages } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;
    const autoTrailerCarouselConfiguration = (autoTrailerCarousel as any) || {};
    const userInfo = getUserInfo();
    const { data: reminderData } = useUserReminders({ detailed: false }, userInfo);

    return (
        <FlexWrapper
            itemCount={{ default: 3, md: itemsCount ? itemsCount : 6 }}
            gap="2x"
            paddingBottom="2x"
            className="catalog-list"
        >
            {(content ?? []).map((item: any, index: number) => {
                return (
                    <FullVODCarouselItem
                        key={`${item?.guid ?? item?.id ?? 'vod'}-${index}`}
                        item={item}
                        index={index}
                        componentType={componentType}
                        componentName={componentName}
                        screenName={screenName}
                        carouselType={carouselType}
                        autoTrailerCarouselConfiguration={autoTrailerCarouselConfiguration}
                        promotionProviderImages={promotionProviderImages}
                        enableLockIcon={enableLockIcon}
                        reminderData={reminderData}
                    />
                );
            })}
        </FlexWrapper>
    );
};
export default FullVODCarousel;
